export default __webpack_public_path__ + "static/media/6785 - SEV.1a1a18db.jpeg";